module.exports = __webpack_public_path__ + "static/media/vision.28c9e96b.png";